/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Moov account capabilities.
 *
 * @remarks
 *
 * The `production-app`, `platform.production-app`, and / or `platform.wallet-transfers` capabilities might appear in your list. These are read-only capabilities that Moov requests and uses for account verification purposes. These capabilities remains active with your account and require no additional action.
 */
export const CapabilityID = {
  Transfers: "transfers",
  SendFunds: "send-funds",
  SendFundsPushToCard: "send-funds.push-to-card",
  MoneyTransferPushToCard: "money-transfer.push-to-card",
  SendFundsAch: "send-funds.ach",
  SendFundsRtp: "send-funds.rtp",
  SendFundsInstantBank: "send-funds.instant-bank",
  CollectFunds: "collect-funds",
  CollectFundsCardPayments: "collect-funds.card-payments",
  MoneyTransferPullFromCard: "money-transfer.pull-from-card",
  CollectFundsAch: "collect-funds.ach",
  Wallet: "wallet",
  WalletBalance: "wallet.balance",
  CardIssuing: "card-issuing",
  ProductionApp: "production-app",
  PlatformProductionApp: "platform.production-app",
  PlatformWalletTransfers: "platform.wallet-transfers",
} as const;
/**
 * Moov account capabilities.
 *
 * @remarks
 *
 * The `production-app`, `platform.production-app`, and / or `platform.wallet-transfers` capabilities might appear in your list. These are read-only capabilities that Moov requests and uses for account verification purposes. These capabilities remains active with your account and require no additional action.
 */
export type CapabilityID = ClosedEnum<typeof CapabilityID>;

/** @internal */
export const CapabilityID$inboundSchema: z.ZodNativeEnum<typeof CapabilityID> =
  z.nativeEnum(CapabilityID);
/** @internal */
export const CapabilityID$outboundSchema: z.ZodNativeEnum<typeof CapabilityID> =
  CapabilityID$inboundSchema;
